import Vue from 'vue'
import Vuex from 'vuex'

import { settingsService } from '@/_services'

import { authentication } from './_store/authentication.module'
import { pages } from './_store/pages.module'
import { tests } from './_store/tests.module'


Vue.use(Vuex)

const locales = [
  {
    value:'ru',
    text:{
        ru:'рус',
        udm:'ӟуч'
    },
    default:true
  },
  {
      value:'udm',
      text:{
        ru:'удм',
        udm:'удм'
      }
  }
  //{value:'en',text:'eng'}
]


const nammedsettings = {
  Enter: {
    ru:"Вход",
    udm: "Вход"
  },
  Registration: {
    ru: "Регистрация",
    udm: "Регистрация"
  },
  FIO: {
    ru: "ФИО",
    udm: "ФИО"
  },
  Password: {
    ru: "Пароль",
    udm: "Пароль"
  },

  Errors_fio_required: {
    ru: "ФИО обязательное поле.",
    udm: "ФИО обязательное поле."
  },
  Errors_bad_email: {
    ru: "E-mail не коректный.",
    udm: "E-mail не коректный."
  },
  Errors_email_required: {
    ru: "E-mail обязательное поле.",
    udm: "E-mail обязательное поле."
  },
  Errors_password_required: {
    ru: "Пароль обязательное поле.",
    udm: "Пароль обязательное поле."
  },

  Test_udm_history: {
    ru: "Тест о жизни и творчестве А. Оки и К. Герда",
    udm: "А. Окилэн но К. Гердлэн улон но творческой сюрессы сярысь тест"
  },

  Main_BUDMDIC_1: {
    ru: "Большой удмуртский диктант",
    udm: "Бадӟым удмурт диктант ортчиз"
  },
  Main_BUDMDIC_2: {
    ru: "состоится 1 апреля 2023 года",
    udm: "1-тӥ оштолэзе 2023-тӥ арын"
  },
  Main_PICHITAT: {
    ru: "Прочитать",
    udm: "Лыдӟоно"
  },
  Main_POSMOTRET: {
    ru: "Посмотреть",
    udm: "Учконо"
  },
  Main_MEMBERS_TITLE: {
    ru: "Участники проекта",
    udm: "Ӵектосэ пыриськисьёс"
  },
  Main_MEMBERS_KENESH: {
    ru: "Межрегиональная общественная организация «Всеудмуртская ассоциация «Удмурт Кенеш»",
    udm: "«Вань удмуртъёслэн «Удмурт Кенеш» улосвылкуспо мер огазеяськонзы"
  },
  Main_MEMBERS_UFFU: {
    ru: "Институт удмуртской филологии, финно-угроведения и журналистики ФГБОУ ВО «УдГУ»",
    udm: "Удмурт кун университетысь Удмурт кылосбуръя, финно-угороведениея но журналистикая институт"
  },
  Main_MEMBERS_MINNAC: {
    ru: "Министерство национальной политики Удмуртской Республики",
    udm: "Удмурт Элькунысь йӧскалык политикая министерство"
  },
  Main_MEMBERS_DDN: {
    ru: "Дом Дружбы народов",
    udm: "«Калыкъёслэн Эшъяськон юртсы» Удмурт Элькунысь коньдэтэн возись-кись ужъюрт"
  },
  Main_MEMBERS_UDMURTIA: {
    ru: "ГУП УР «Телерадиовещательная компания «Удмуртия»",
    udm: "«Удмуртия» телерадиовещательной компания» Удмурт Элькунысь кун уни-тар предприяти"
  },

  Test_TITLE: {
    ru: "Тест о жизни и творчестве А. Оки и К. Герда",
    udm: "А. Окилэн но К. Гердлэн улон но творческой сюрессы сярысь тест"
  },
  Test_REGISTRACIYA: {
    ru: "Регистрация участника",
    udm: "Гожтӥськон"
  },
  Test_IMYA: {
    ru: "Имя",
    udm: "Нимтул"
  },
  Test_PROITI_TEST: {
    ru: "Пройти онлайн тест",
    udm: "Онлайн тест ортчоно"
  },

  DICT_RESULT: {
    ru: "Результаты",
    udm: "Йылпумъянъёс"
  },
  DICT_SEARCH: {
    ru: "Поиск результатов",
    udm: "Йылпумъянъёсты утчан"
  },
  DICT_IMYA: {
    ru: "Имя",
    udm: "Ним"
  },
  DICT_FAMIL: {
    ru: "Фамилия",
    udm: "Фамилия"
  },
  DICT_OTCH: {
    ru: "Отчество",
    udm: "Атайним"
  },
  DICT_NAITY: {
    ru: "Найти",
    udm: "Шедьтоно"
  },
  DICT_SEARCH_RESULT: {
    ru: "Результат поиска",
    udm: "Мар сётӥз утчан"
  },
  DICT_SPS_1: {
    ru: "Спасибо за участие в Межрегиональной образовательной акции «Бадӟым удмурт диктант»!  Вы набрали",
    udm: "Тау «Бадӟым удмурт диктант» акцие пыриськемды понна! Тӥ люкады 100 балл пӧлысь"
  },
  DICT_SPS_2: {
    ru: "баллов из 100",
    udm: "балл"
  },
  DICT_SKACHAT: {
    ru: "Скачать сертификат",
    udm: "Сертификатэз поттоно"
  },
  DICT_RES_MORE: {
    ru: "По Вашему запросу найдено более 1 совпадения. Попробуйте уточнить информацию в списке",
    udm: "Шедизы 1-лэсь трос нимъёс. Дэмласькомы эскерыны та списокъя"
  },
  DICT_NO_RES: {
    ru: "По Вашему запросу совпадений не найдено. Попробуйте уточнить информацию в списке",
    udm: "Таӵе ним ӧз шедьы. Дэмласькомы эскерыны та списокъя"
  },
  DICT_Q_1: {
    ru: "Если у Вас возникли вопросы, Вы можете обратиться к ", 
    udm: "Юанъёсты кылдӥзы ке, вазиськыны быгатӥськоды "
  },
  DICT_Q_2: {
    ru: "организаторам", 
    udm: "радъясьёс доры"
  }
}

const store =  new Vuex.Store({
  state: {
    locales,
    locale: 'ru',

    settings: [],
    nammedsettings,


    dictantFile: null,
    dictantSertificatFile: null,

    testSertificatFile: null
  },

  getters: {
    getLocale(state){
      return state.locale
    },

    localize: state => key => {
      let out = `[LOCALIZATION ERROR]: Key ${key} not found`
      let e = state.nammedsettings[key]
      if (e) {
        let v = e[state.locale]
        if (v) out = v
      }
      return out
    }
  },

  mutations: {
    setLocale: (state, payload) => {
      state.locale = payload.value
    },

    setSettings: (state, settings) => {
      state.settings = settings

      settings.forEach(el => {
        el.value?.forEach(val => {
          if (state.nammedsettings[el.key]) {
            state.nammedsettings[el.key][val.locale] = val.text
          } else {
            state.nammedsettings[el.key] = {}
            state.nammedsettings[el.key][val.locale] = val.text
          }
        })
      })
    },

    setDictantFile: (state, dictantFile) => {
      state.dictantFile = dictantFile
    },

    setDictantSertificatFile: (state, dictantSertificatFile) => {
      state.dictantSertificatFile = dictantSertificatFile
    },

    setTestSertificatFile: (state, testSertificatFile) => {
      state.testSertificatFile = testSertificatFile
    },
  },

  actions: {
    INIT_SETTINGS: ({ commit }) => {
      settingsService.loadSettings().then(data => {
        commit('setSettings', data.localeSettings)

        commit('setDictantFile', data.dictantFile)
        commit('setDictantSertificatFile', data.dictantSertificatFile)

        commit('setTestSertificatFile', data.testSertificatFile)
        
    })
    }
  },

  modules: {
    authentication,
    pages,
    tests
  }
})

export default store